export const getStoredAuthToken = () => localStorage.getItem('asfbu');

export const storeAuthToken = token => localStorage.setItem('asfbu', token);

export const removeStoredAuthToken = () => localStorage.removeItem('asfbu');

export const getAppAuthToken = () => localStorage.getItem('atu');

export const appAuthToken = token => localStorage.setItem('atu', token);

export const removeAppAuthToken = () => localStorage.removeItem('atu');

export const getLoginCount = () => Number(localStorage.getItem('loginCount')) || 0;

export const increaseLoginCount = () => localStorage.setItem('loginCount', getLoginCount() + 1);

export const getIsPurchase = () => localStorage.getItem('isPurchase');

export const setIsPurchase = bool => localStorage.setItem('isPurchase', bool);

export const setTokenCode = token => localStorage.setItem('tokenCode', token);

export const getTokenCode = () => localStorage.getItem('tokenCode');

export const removeTokenCode = () => localStorage.removeItem('tokenCode');
